import React from 'react';
import PropTypes from 'prop-types';
import { Panel } from 'react-bootstrap';
import BarChartComponent from './BarChartComponent';

const BarStatsComponent = ({
  style,
  title,
  barData,
  link,
  series,
  onClick,
  yMax
}) => (
  <div>
    <Panel bsStyle={style}>
      <Panel.Heading>
        <Panel.Title>
          <div>
            {title}
            {link ? <a href={link} style={{ float: 'right' }}>Link</a> : null}
          </div>
        </Panel.Title>
      </Panel.Heading>
      <BarChartComponent height={100} data={barData}
        series={series} onClick={onClick}
        noLegend yMin={0} yMax={yMax}
      />
    </Panel>
  </div>
);

BarStatsComponent.propTypes = {
  style: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  barData: PropTypes.arrayOf(PropTypes.number).isRequired,
  link: PropTypes.string,
  series: PropTypes.arrayOf(PropTypes.shape({
    colour: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  onClick: PropTypes.func.isRequired,
  yMax: PropTypes.number.isRequired
};

export default BarStatsComponent;


// WEBPACK FOOTER //
// src/Components/BarStatsComponent.jsx